import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { type DocumentDetails } from "~/api/types";
import { DocumentMetadataView } from "~/molecules/DocumentMetadataSections";
import { DocumentMetadataEdit } from "~/molecules/DocumentMetadataEdit";
import { useState } from "react";
import { canEditDocumentMetadata } from "~/helpers/documentPermissions";

interface Props {
  document: DocumentDetails;
  releaseId: number;
  onSave: () => void;
  onEditModeChange?: (isEditing: boolean) => void;
  onUnsavedChangesChange?: (hasUnsavedChanges: boolean) => void;
}

export function DocumentMetadata({
  document,
  releaseId,
  onSave,
  onEditModeChange,
  onUnsavedChangesChange,
}: Props) {
  const { t } = useTranslation();
  const [isEditingMetadata, setIsEditingMetadata] = useState(false);

  const startEditing = () => {
    setIsEditingMetadata(true);
    onEditModeChange?.(true);
  };

  const stopEditing = () => {
    setIsEditingMetadata(false);
    onEditModeChange?.(false);
    onUnsavedChangesChange?.(false);
  };

  const selectedRelease = document.releases.find(
    (release) => release.id === releaseId,
  );
  const canEditMetadata = selectedRelease
    ? canEditDocumentMetadata(selectedRelease, document.archivedAt)
    : false;

  return (
    <div className="flex flex-col gap-4">
      {!isEditingMetadata ? (
        <>
          {canEditMetadata && (
            <Button variant="outline" onClick={startEditing}>
              {t(($) => $.commons.buttons.editMetadata)}
            </Button>
          )}
          <DocumentMetadataView document={document} />
        </>
      ) : (
        canEditMetadata && (
          <DocumentMetadataEdit
            document={document}
            onSave={onSave}
            onCancel={stopEditing}
            onUnsavedChangesChange={onUnsavedChangesChange}
          />
        )
      )}
    </div>
  );
}
